import React from 'react';

import cn from 'classnames';
import Image from 'next/legacy/image';

import { IOpenBaseModalParams, ModalBaseProps, openBaseModal } from '@element/index';
import bg from '@images/airdrop/boxBgModal.webp'

import styles from './index.module.less';

export interface ModalBgProps extends ModalBaseProps {
  /** 弹窗整体 class */
  className?: string;
  /** 弹窗背景 class */
  bgClassName?: string;
}

const ModalBg: React.FC<ModalBgProps> = (props) => {
  const { className, bgClassName, children, ...rest } = props;
  return (
    <div className={styles.containerModal}>
      <div className={cn(className, styles.container)}>
        <div className={cn(className, styles.bg)}>
          <Image src={bg} layout="fill" alt='kikitrade'/>
        </div>
        {children(rest)}
      </div>
    </div>
  )
}

export interface IOpenModalBgParams extends IOpenBaseModalParams, Omit<ModalBgProps, 'reject' | 'resolve' | 'removePreview'> { }

export const openModalBg = ({ el, children, className }: IOpenModalBgParams) => {
  return openBaseModal({
    el,
    children: (params) => <ModalBg className={className} {...params}>{children}</ModalBg>
  })
}
